'use client';
import React from 'react';
import Image from 'next/image';
import { useParams } from 'next/navigation';
import cn from './style.module.scss';

export default function HouseLogo(props: any) {
  const { lang } = useParams();
  return (
    <div className={cn.brandLogo}>
      <Image
        width={203}
        height={76}
        src={props.logoImage.url}
        alt="logo image "
      />
    </div>
  );
}
